module.exports = __webpack_public_path__ + "img/compass.0056217e.svg";